import { Component, OnInit } from '@angular/core';

import { AuthService } from 'src/app/services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-status',
  template: '',
})
export class StatusComponent implements OnInit {
  redirectUrl: string;
  code: string;
  sourceUrl: string;

  constructor(private auth: AuthService, private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    // get necessary query params
    this.activatedRoute.queryParams.subscribe(
      params => {
        this.code = params.code;
        this.redirectUrl = params.redirectUrl;
        this.sourceUrl = params.sourceUrl;
      }
    );
    // if no value in source url set default value
    if (!this.redirectUrl) {
      this.redirectUrl = 'http://localhost:4000/dashboard/';
    }
    // if no value in source url set default value
    if (!this.sourceUrl) {
      this.sourceUrl = '';
    }
    // validate code to check access token for user
    if (this.code) {
      this.validateCode(this.code);
    } else if (localStorage.getItem('code')) {
      this.validateCode(localStorage.getItem('code'));
    } else {
      this.router.navigate(['/auth/employee/login'], { queryParams: { redirectUrl: this.redirectUrl, sourceUrl: this.sourceUrl}});
    }
  }

  validateCode(code: string) {
    console.log('code', code);
    // check if token exists and then keep session or send to login page to authenticate user
    this.auth.getToken(code).subscribe(
      resToken => {
        if (resToken.status) {
          localStorage.setItem('token', resToken.token);
          window.location.href = this.redirectUrl + '?code=' + code + '&sourceUrl=' + this.sourceUrl;
        } else {
          localStorage.clear();
          this.router.navigate(['/auth/employee/login'], { queryParams: { redirectUrl: this.redirectUrl, sourceUrl: this.sourceUrl}});
        }
      },
      err => {
        if (err.status === 403) {
          localStorage.clear();
          this.router.navigate(['/auth/employee/login'], { queryParams: { redirectUrl: this.redirectUrl, sourceUrl: this.sourceUrl}});
        }
      }
    );
  }

}
